// var object = require('lodash/fp/object');
import nanoScroller from "@global/vendors/jquery.nanoscroller.min";
import Vue from "vue";
import cartNotification from "@global/components/cart/cartNotification";
import AlertDialog from "@global/helpers/alertDialog";
// import aqTrace from '@global/components/tracing/aq';
import store from "@global/components/store/index.js";
import { createNamespacedHelpers } from "vuex";
const { mapState, mapActions, mapGetters } = createNamespacedHelpers("miniCartModule");
import GlobalCtrl from "./globalCtrl";
import messageBox from "@global/helpers/messageBox";
if (process.env.NODE_ENV === "development") {
	Vue.config.devtools = true;
}

global.$ = global.jQuery = require("jquery"); // fix can't use JQ in inline script

// require('@global/vendors/slick')
require("sticky-kit/dist/sticky-kit");
// console.log(globalCtrl)
import NewImage from "@global/components/global/image";
if ($("#app-mini-cart").length > 0) {
	window.appNotificationCart = new Vue({
		el: "#app-mini-cart",
		store,
		components: { NewImage },
		computed: {
			...mapState([
				"totalCount",
				"generalCount",
				"refrigerationCount",
				"freezingCount",
				"temperaturesData",
				"dataIsLoad",
				"count",
				"hotSearch",
				"hotLoad",
			]),
			...mapGetters(["isOnlyOneTemp", "getHotSearch"]),
		},
		data() {
			return {
				cartContentHeight: "",
				hasProduct: 0,
				showProduct: false,
			};
		},
		watch: {
			totalCount: function (val) {
				this.onSetCartHeight();
			},
		},
		created() {
			this.getCartInfo();
			this.getHotSearch();
		},
		methods: {
			...mapActions(["getCartInfo", "getHotSearch"]),
			onSetCartHeight() {
				if (this.totalCount !== 0) {
					if (this.isOnlyOneTemp && this.generalCount !== 0) {
						this.showProduct = true;
						if (this.temperaturesData[0].Markets.length > 4) {
							this.cartContentHeight = (4 * 68).toString() + "px";
							document.getElementById("miniCart-all").style.overflowY = "scroll";
						} else {
							this.cartContentHeight = (this.temperaturesData[0].Markets.length * 68).toString() + "px";
						}
						document.getElementById("miniCart-all").style.height = this.cartContentHeight;
					} else {
						if (this.generalCount !== 0) {
							this.hasProduct++;
						}

						if (this.refrigerationCount !== 0) {
							this.hasProduct++;
						}

						if (this.freezingCount !== 0) {
							this.hasProduct++;
						}
						this.cartContentHeight = (this.hasProduct * 55).toString() + "px";
						document.getElementById("miniCart-all").style.height = this.cartContentHeight;
						this.hasProduct = 0;
					}
				}
			},
			goSearch(item) {
				window.location.href = "/search?Keyword=" + item;
			},
			spread() {
				$(".hot-input-block").addClass("open");
				$(".hot-cancel").css("display", "inline-block");
			},
			cancel() {
				$(".hot-input-block").removeClass("open");
				$(".hot-cancel").css("display", "none");
				$(".hot-input").val("");
			},
		},
	});
}

GlobalCtrl();

// 電子報
window.RecordNewsletter = function () {
	$.ajax({
		type: "POST",
		url: "/api/v1/Subscribe/Apply",
		dataType: "json",
		data: { Email: $("#input-newsletter").val() },
		xhrFields: {
			withCredentials: false,
		},
		error: function () {
			console.log("error");
		},
		success: function (res) {
			AlertDialog.alert(res.Message);
			// aqTrace.subscribedMail({mail: $("#input-newsletter").val()})
		},
	});
};

// 全域方法前後端使用
window.AlertDialog = AlertDialog;
window.messageBox = messageBox;
window.Vue = Vue;
